<template>
  <div class="ext">
    <div class="head-box">
      <h4>{{ templateTypeTitle }}</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入标题/扩展标识"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">创建</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          style="width: 100%"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column
            prop="title"
            label="标题"
            width="200px"
            show-overflow-tooltip
            fixed
          ></el-table-column>
          <el-table-column
            prop="colName"
            label="扩展标识"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            v-if="templateType == 'TT4'"
            prop="parentColName"
            label="父业务档案"
            width="140px"
            :formatter="formatParentColName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="state" label="状态" width="140px">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140px"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="140px"></el-table-column>
          <el-table-column prop="content" label="描述" show-overflow-tooltip></el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="templateType != 'TT5'"
                    @click.native="doEdit(scope.row, 'copy')"
                  >
                    复制
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="templateType != 'TT5'"
                    @click.native="doInsert(scope.row)"
                  >
                    插入脚本
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doToExtFields(scope.row)">
                    属性管理
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="
                      $router.push({ path: 'FormDesigner', query: { extId: scope.row._id } })
                    "
                  >
                    可视化表单配置
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
        <el-dialog :title="templateTypeTitle" :visible.sync="openDetail">
          <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-width="100px"
            label-position="left"
          >
            <template v-if="isInsert">
              <el-form-item label="前置脚本">
                <el-input type="textarea" v-model="formData.preScriptContent"></el-input>
              </el-form-item>
              <el-form-item label="后置脚本">
                <el-input type="textarea" v-model="formData.scriptContent"></el-input>
              </el-form-item>
              <el-form-item label="归档脚本">
                <el-input type="textarea" v-model="formData.delScriptContent"></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item v-if="formData.exts.copy">
                <el-tag type="warning">
                  请填写新表单的标题和扩展标识
                </el-tag>
              </el-form-item>
              <el-form-item label="标题" prop="title">
                <el-input v-model="formData.title"></el-input>
              </el-form-item>
              <el-form-item
                label="扩展标识"
                prop="colName"
                :rules="{
                  required: true,
                  trigger: 'change',
                  message: '不能为空'
                }"
              >
                <el-select
                  v-if="templateType == 'TT1'"
                  v-model="formData.colName"
                  clearable
                  :disabled="formData._id"
                >
                  <el-option
                    v-for="item in options.colName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                      {{ item.value }}
                    </span>
                  </el-option>
                </el-select>
                <el-input v-else v-model="formData.colName" :disabled="formData._id"></el-input>
              </el-form-item>
              <el-form-item
                label="父业务档案"
                prop="parentColName"
                v-if="templateType == 'TT4' && !formData.exts.copy"
              >
                <el-select
                  v-model="formData.parentColName"
                  :clearable="true"
                  placeholder="非必填，请选择归属的业务档案"
                >
                  <el-option
                    v-for="item in options.colName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right">
                      {{ item.value }}
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="描述" v-if="!formData.exts.copy">
                <el-input v-model="formData.content" type="textarea" :rows="2"></el-input>
              </el-form-item>
              <el-form-item label="顶部操作按钮" prop="colName" v-if="!formData.exts.copy">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                  v-model="formData.exts.actions"
                ></el-input>
              </el-form-item>
            </template>
          </el-form>
          <div slot="footer">
            <el-button type="primary" @click="doCopy" v-if="formData.exts.copy">复 制</el-button>
            <el-button type="primary" @click="doSave" v-else>确 定</el-button>
            <el-button @click="doInit">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ext',
  data() {
    return {
      searchValue: '',
      fpi: {},
      openDetail: false,
      options: {
        codecfg_type: { codeId: 'EXT_TYPE' }, // type: [{ label: "表单", value: "0" }, { label: "实体扩展", value: "1" }]
        codecfg_colName: { codeId: 'colName' }
      },
      formData: { exts: {} },
      rules: this.$util.rules,
      //当前扩展类型
      templateType: '',
      //标题
      templateTypeTitle: '',
      tenantId: '',
      //权限
      permissions: {},
      isInsert: false //判断是否是插入脚本
    };
  },
  mounted() {
    window.$this = this;
    this.osg.getFpi();
    this.doInit();
  },
  methods: {
    formatType(row, column, cellValue) {
      return this.osg.codelabel('type', cellValue);
    },
    formatParentColName(row, column, cellValue) {
      return this.osg.codelabel('colName', cellValue);
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doEnable(id) {
      this.osg.ajax('biz/ext/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('biz/ext/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doInit() {
      this.templateType = this.osg.param('templateType');
      this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
      this.openDetail = false;
      this.formData = { exts: {} };
      switch (
        this.templateType //2,3在Workflows
      ) {
        case 'TT1':
          this.templateTypeTitle = '业务档案';
          break;
        case 'TT4':
          this.templateTypeTitle = '服务步骤';
          break;
        case 'TT5':
          this.templateTypeTitle = '报单配置';
          break;
        case 'serviceAppointment':
          this.templateTypeTitle = '工单模板';
          break;
        default:
          this.templateTypeTitle = '扩展管理';
      }
      this.osg.codeoption(() => {
        this.getData();
      });
      if (this.$refs.formData) {
        this.$refs.formData.resetFields();
      }
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:title|string#or': this.searchValue,
        'regex:colName|string#or': this.searchValue,
        'in:templateType|string#and': this.templateType,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'asc'
      };
      this.osg.setFpi(params);
      this.osg.ajax(
        'biz/ext/query.do',
        params,
        res => {
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.isInsert = false;
    },
    doEdit(row, type) {
      row = this.$util.deepCopy(row);
      row.exts = row.exts || {};
      if (type == 'copy') row.exts.copy = true;
      this.formData = row;
      this.openDetail = true;
    },
    doCopy() {
      if (this.osg.validate()) {
        this.osg.ajax(
          'biz/extForm/copyExtForm.do',
          {
            extId: this.formData._id,
            title: this.formData.title,
            colName: this.formData.colName
          },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('复制成功！');
          }
        );
      }
    },
    doSave() {
      let type = '';
      switch (
        this.templateType //2,3在Workflows
      ) {
        case 'TT1':
          type = '1';
          break;
        case 'TT4':
          type = '0';
          break;
        case 'TT5':
          break;
        case 'serviceAppointment':
          type = '1';
          break;
        default:
          type = '2';
      }
      let param = this.$util.deepCopy(this.formData);
      param.templateType = this.templateType;
      param.type = type;
      if (this.osg.validate()) {
        param.groupNumber = param.groupNumber || 1;
        this.osg.ajax('biz/ext/upsert.do', param, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doToExtFields(data) {
      let that = this;
      this.$router.push({
        path: '/extFields',
        query: {
          _id: data._id,
          colName: data.colName,
          templateType: that.templateType
        }
      });
    },
    doInsert(row) {
      this.isInsert = true;
      row.exts = row.exts || {};
      this.formData = row;
      this.openDetail = true;
    }
  },
  watch: {
    $route() {
      this.osg.getFpi();
      this.doInit();
    }
  }
};
</script>
<style scoped>
#app .ext .content-table ::v-deep .el-input__suffix {
  display: block !important;
}
</style>
